/* tslint:disable */
/* eslint-disable */
/**
 * Store
 * 店舗向けAPI
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetSale200ResponseAllOfData } from './GetSale200ResponseAllOfData';
import {
    GetSale200ResponseAllOfDataFromJSON,
    GetSale200ResponseAllOfDataFromJSONTyped,
    GetSale200ResponseAllOfDataToJSON,
} from './GetSale200ResponseAllOfData';

/**
 * 
 * @export
 * @interface GetSale200Response
 */
export interface GetSale200Response {
    /**
     * 
     * @type {GetSale200ResponseAllOfData}
     * @memberof GetSale200Response
     */
    data: GetSale200ResponseAllOfData;
    /**
     * 
     * @type {object}
     * @memberof GetSale200Response
     */
    meta: object;
}

/**
 * Check if a given object implements the GetSale200Response interface.
 */
export function instanceOfGetSale200Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;
    isInstance = isInstance && "meta" in value;

    return isInstance;
}

export function GetSale200ResponseFromJSON(json: any): GetSale200Response {
    return GetSale200ResponseFromJSONTyped(json, false);
}

export function GetSale200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetSale200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': GetSale200ResponseAllOfDataFromJSON(json['data']),
        'meta': json['meta'],
    };
}

export function GetSale200ResponseToJSON(value?: GetSale200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': GetSale200ResponseAllOfDataToJSON(value.data),
        'meta': value.meta,
    };
}

